import type { AreaSubstrate } from 'paintscout'
import type { UpdateableAreaSubstrate } from '../../index'
import { toSaveableHours, toSaveablePrice, toSaveableProducts, toSaveableRate } from './util'
/**
 * Convert an updateableAreaSubstrate to an areaSubstrate
 * with baseAreaSubstrate as defaults/original
 * (this is own base, or a default baseAreaSubstrate for a new areaSubstrate)
 * @param baseAreaSubstrate - the base areaSubstrate
 * @param areaSubstrate - the areaSubstrate to convert
 * @returns areaSubstrate to add to quote
 */
export default function toAreaSubstrate(
  baseAreaSubstrate: AreaSubstrate,
  areaSubstrate: UpdateableAreaSubstrate
): AreaSubstrate {
  const { product: _product, ...cleanBaseAreaSubstreate } = baseAreaSubstrate // Remove old product off of baseAraSubstrate, just use products
  return {
    ...cleanBaseAreaSubstreate,
    quantity: typeof areaSubstrate.quantity === 'string' ? parseFloat(areaSubstrate.quantity) : areaSubstrate.quantity,
    section: {
      ...baseAreaSubstrate.section,
      value: areaSubstrate.section
    },
    workOrderOnly: areaSubstrate.workOrderOnly,
    hourlyRate:
      typeof areaSubstrate.hourlyRate === 'string' ? parseFloat(areaSubstrate.hourlyRate) : areaSubstrate.hourlyRate,
    overrideHourlyRate: areaSubstrate.overrideHourlyRate,
    useInches: areaSubstrate.useInches,
    showPrice: areaSubstrate.showPrice,
    showProduct: areaSubstrate.showProduct,
    showCoats: areaSubstrate.showCoats,
    showPrep: areaSubstrate.showPrep,
    showDimensions: areaSubstrate.showDimensions,
    hideQuantity: areaSubstrate.hideQuantity,
    hideQuantityOnWorkOrder: areaSubstrate.hideQuantityOnWorkOrder,
    excludeDiscount: areaSubstrate.excludeDiscount,
    excludeTax: areaSubstrate.excludeTax,
    use_total: areaSubstrate.use_total,
    ...toSaveableRate(areaSubstrate),
    products: toSaveableProducts(baseAreaSubstrate, areaSubstrate),
    coats: areaSubstrate.coats,
    prep: areaSubstrate.prep,
    notes: areaSubstrate.notes,
    length: areaSubstrate.length?.useCustom ? areaSubstrate.length.custom : areaSubstrate.length?.default,
    override_length: areaSubstrate?.length?.useCustom ?? false,
    height: areaSubstrate.height?.useCustom ? areaSubstrate.height.custom : areaSubstrate.height?.default,
    override_height: areaSubstrate?.height?.useCustom ?? false,
    width: areaSubstrate.width?.useCustom ? areaSubstrate.width.custom : areaSubstrate.width?.default,
    override_width: areaSubstrate.width?.useCustom ?? false,
    override_dimensions: areaSubstrate?.dimensionOverride?.useCustom ?? false,
    override_dimensions_value: areaSubstrate?.dimensionOverride?.custom ?? 0,
    show_override_dimensions: areaSubstrate.showOverrideDimensions,
    ...toSaveableHours(areaSubstrate),
    ...toSaveablePrice(areaSubstrate)
  }
}
